export default function(http) {
  return {
    queryByPage(data) {
      return http.json({
        url: `/village/queryPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        data,
      });
    },
    queryByPages(data) {
      return http.json({
        url: `/system/user/queryPage`,
        data,
      });
    },
    save(data) {
      return http.json({
        url: "/system/sysRepairPersonnel/save",
        data,
      });
    },
    //详情
    getsysRepairPersonnel({ id }) {
      return http.json({
        url: `/system/sysRepairPersonnel/get?id=${id}`,
      });
    },
    deleteSysRepairPersonnel(params) {
      return http.json({
        url: "/system/sysRepairPersonnel/delete",
        params,
      });
    },

    listSysRepairPersonnel(villageId) {
      return http.json({
        url: "/system/sysRepairPersonnel/listSysRepairPersonnel",
        params: {
          villageId: villageId,
        },
      });
    },

    queryByCode(data) {
      return http.json({
        url: `/system/dict/e/${data.code}`,
        data,
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/sysRepairPersonnel.js